import { Typography, IconButton, Menu, MenuItem } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
// import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
// import { Languages, languages } from "../../../locales/i18n";
import AvatarComponent from "./AvatarComponent";
import mail_icon from "@/assets/mail_icon.svg";
import global_icon from "@/assets/global_icon.svg";
import newTopbarLogo from "@/assets/img/newTopbarLogo.svg";
import { RootState } from "@/redux/rootReducer";
import { getCurrentPlan } from "@/redux/organization/selector";
import Loader from "@/components/Loader";
import i18n from "@/locales/i18n";
import { useTranslation } from "react-i18next";

function TopBar() {
	const history = useHistory();
	const { i18n } = useTranslation();
	const { topBar } = useSelector((state: RootState) => state.global);
	const currentPlan = useSelector(getCurrentPlan);
	const [anchorLanguageEl, setAnchorLanguageEl] = React.useState<null | HTMLElement>(
		null,
	);
	const languageMenuOpen: boolean | undefined = Boolean(anchorLanguageEl);

	// const { t, i18n } = useTranslation();

	// const handleChangeLanguage = (lang: Languages) => {
	// 	i18n.changeLanguage(lang);
	// };

	if (!topBar) {
		return <></>;
	}

	if (!currentPlan) {
		return <Loader />;
	}

	const handleLanguageClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorLanguageEl(event.currentTarget);
	};

	const handleLanguageChange = (language: string) => {
		localStorage.setItem("language", language);
		i18n.changeLanguage(language);
	};

	const handleLanguageClose = () => {
		setAnchorLanguageEl(null);
	};

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				backgroundColor: "#320E61",
			}}
		>
			<div
				style={{
					display: "flex",
					marginLeft: "2rem",
					cursor: "pointer",
					textAlign: "center",
				}}
				onClick={() => {
					history.push(`/`);
				}}
			>
				<Typography
					sx={{
						color: "#FFFFFF",
						fontSize: "1.5rem",
						fontWeight: "bold",
						padding: "1rem",
					}}
				>
					<img
						width={200}
						height={36}
						src={newTopbarLogo}
						style={{ margin: "auto", display: "block" }}
						alt="사진없음"
					/>
				</Typography>
			</div>

			<div style={{ display: "flex", marginRight: "2rem", alignItems: "center" }}>
				<Typography
					sx={{
						color: "#FFFFFF",
						marginRight: "1rem",
					}}
				>
					{i18n.language === "ko" && (
						<>
							{currentPlan.paymentPlan ? (
								<span>
									🚀 푸드렌즈 {currentPlan.paymentPlan.title}
									{currentPlan.paymentPlan.title === "Unlimited"
										? " 플랜"
										: ` ${currentPlan.paymentPlan?.remainingDays}일 남음.`}
								</span>
							) : (
								"🚀 푸드렌즈 플랜 등록 필요"
							)}
						</>
					)}

					{i18n.language === "en" && (
						<>
							{currentPlan.paymentPlan ? (
								<span>
									🚀 FoodLens {currentPlan.paymentPlan.title}
									{currentPlan.paymentPlan.title === "Unlimited"
										? " Plan"
										: ` Plan has ${currentPlan.paymentPlan.remainingDays} days remaining.`}
								</span>
							) : (
								"🚀 FoodLens Plan registration required."
							)}
						</>
					)}
				</Typography>

				<button
					style={{
						height: "2rem",
						width: "5rem",
						color: "white",
						backgroundColor: "#0071E3",
						borderRadius: "4px",
						border: "none",
						marginRight: "1rem",
						cursor: "pointer",
					}}
					onClick={() => {
						history.push(`/price`, {
							appId: 0,
							appName: currentPlan.paymentPlan?.title,
							isUse: true,
						});
					}}
				>
					Upgrade
				</button>
				<IconButton
					onClick={() => {
						history.push(`/organization/contact`);
					}}
				>
					<img src={mail_icon} alt="사진없음" />
				</IconButton>
				<IconButton
					id="language-button"
					aria-controls={languageMenuOpen ? "language-menu" : ""}
					aria-haspopup="true"
					aria-expanded={languageMenuOpen}
					onClick={handleLanguageClick}
				>
					<img src={global_icon} alt="사진없음" />
				</IconButton>
				<Menu
					id="basic-menu"
					anchorEl={anchorLanguageEl}
					open={languageMenuOpen}
					onClose={handleLanguageClose}
					MenuListProps={{
						"aria-labelledby": "language-button",
					}}
				>
					<MenuItem onClick={() => handleLanguageChange("ko")}>한국어</MenuItem>
					<MenuItem onClick={() => handleLanguageChange("en")}>
						English
					</MenuItem>
				</Menu>
				<div
					style={{
						margin: "0px 10px 0px 10px",
						borderLeft: "1px solid rgba(38, 31, 31, 0.2)",
						height: "34px",
					}}
				/>
				<AvatarComponent />

				{/* <div>
					{isAuthenticated && <div>로그인중</div>}
					<p>{t("hello")}</p>
					{languages.map((lang) => (
						<button key={lang} onClick={() => handleChangeLanguage(lang)}>
							{t(`language_${lang}`)}
						</button>
					))}
				</div> */}
			</div>
		</div>
	);
}

export default TopBar;
